// removed by extract-text-webpack-plugin
module.exports = {"logo":"_2J2cbh1nnYAkxHJp8yAQV2","title":"_1rd3wIaVkq9t6wD4Ho7Xvk","attention":"_2qV1tqQQgk2mF_AdjHIzOG","content":"_3KXlQ-j6iSn9KO9uaSNWzV","text":"_3EYvrRkhhDsY3cScN0lkca","loadImg":"_230AzmDSRB50FZqUXQKIPd","bounce":"_2FkKTVdpcB95Gl2bOJwgQN"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AlipayModal/AlipayModal.scss
 ** module id = 945
 ** module chunks = 0
 **/